import { cards } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-4xl font-display text-foreground-950">
              深度爆料
            </h2>
            <p className="mt-2 text-sm md:text-base text-foreground-500">
              独家内幕深度解析，还原事件真实全貌
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {cards.slice(0, 6).map((item) => (
              <article
                key={item.id}
                className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-300 transition-colors duration-300 cursor-pointer"
              >
                <div className="relative aspect-[3/2] overflow-hidden bg-background-100">
                  <img
                    src={item.image}
                    alt={`吃瓜爆料深度内容 - ${item.title}`}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <span className="absolute top-3 left-3 px-2.5 py-1 bg-accent-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="text-base md:text-lg font-display text-foreground-900 mb-2 line-clamp-2 hover:text-primary-500 transition-colors duration-200">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                    {item.summary}
                  </p>
                  <div className="flex items-center gap-4 text-xs text-foreground-400">
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line w-3 h-3 flex items-center justify-center"></i>
                      {item.date}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line w-3 h-3 flex items-center justify-center"></i>
                      {item.views}
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>

          <div className="mt-5">
            <article className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-300 transition-colors duration-300 cursor-pointer flex flex-col md:flex-row">
              <div className="relative w-full md:w-[360px] aspect-[3/2] md:aspect-auto overflow-hidden bg-background-100 flex-shrink-0">
                <img
                  src={cards[6].image}
                  alt={`吃瓜爆料深度内容 - ${cards[6].title}`}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-accent-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                  {cards[6].tag}
                </span>
              </div>
              <div className="p-4 md:p-6 flex flex-col justify-center">
                <h3 className="text-lg md:text-xl font-display text-foreground-900 mb-2 hover:text-primary-500 transition-colors duration-200">
                  {cards[6].title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-3">
                  {cards[6].summary}
                </p>
                <div className="flex items-center gap-4 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line w-3 h-3 flex items-center justify-center"></i>
                    {cards[6].date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line w-3 h-3 flex items-center justify-center"></i>
                    {cards[6].views}
                  </span>
                </div>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
}